import { useEffect, useRef } from 'react';

const TARGETING_COOKIE_ARRAY = ['C0002', 'C0004'];

const stringToArray = (str: string) => (str ? str.slice(1, -1).split(',') : []);

const isAcceptedAllCookies = (cookieList: string[]) =>
    cookieList.some((value) => TARGETING_COOKIE_ARRAY.includes(value));

type UseOneTrustInitParams = {
    onConsent?: () => void;
};

export const useOneTrust = ({ onConsent }: UseOneTrustInitParams) => {
    const consentCalledRef = useRef(false);

    useEffect(() => {
        const interval = setInterval(() => {
            const oneTrust = window.OneTrust;

            if (!oneTrust) return;

            const isBannerClosed = oneTrust.IsAlertBoxClosed?.();
            const cookieList = isBannerClosed ? stringToArray(window.OptanonActiveGroups) : [];

            const isAllowed = isAcceptedAllCookies(cookieList);

            if (isAllowed && !consentCalledRef.current) {
                consentCalledRef.current = true;
                onConsent?.();
            }

            if (!isBannerClosed && oneTrust.OnConsentChanged) {
                oneTrust.OnConsentChanged(({ detail }: { detail: string[] }) => {
                    const isAllowed = isAcceptedAllCookies(detail);

                    if (isAllowed && !consentCalledRef.current) {
                        consentCalledRef.current = true;
                        onConsent?.();
                    }
                });
            }

            clearInterval(interval);
        }, 200);

        return () => clearInterval(interval);
    }, [onConsent]);
};
